module.exports = __webpack_public_path__ + "static/media/uss.46592e73.png";